import axios from "axios";
const API_BASE2 = "https://staging.via-app.ca/via_api/api"; // Production backend URL
const AUTH_KEY = "authToken";
let cachedUser = null;
let verifiedOnce = false;
let mePromise = null;

const api = axios.create({ baseURL: API_BASE2 });
api.interceptors.request.use((config) => {
    try {
        const token = localStorage.getItem(AUTH_KEY);
        if (token) {
            config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
        }
    } catch (_) { } return config;
});

export function isAuthenticated() {
    try {
        const token = localStorage.getItem(AUTH_KEY);
        if (!token) return false;
        if (!verifiedOnce) {
            if (!mePromise) {
                mePromise = getMe()
                    .then((res) => {
                        if (res.success) { cachedUser = res.user; }
                        else { try { localStorage.removeItem(AUTH_KEY); } catch (_) { } cachedUser = null; }
                    })
                    .catch(() => { })
                    .finally(() => { verifiedOnce = true; mePromise = null; });
            }
        }
        return true;
    } catch (e) { return false; }
}

export async function login({ email, password }) {
    try {
        const res = await api.post("/auth/login", { email, password });
        const token = res.data?.token; if (!token) { return { success: false, message: res.data?.error || "No token returned" }; } try { localStorage.setItem(AUTH_KEY, token); } catch (_) { return { success: false, message: "Unable to save auth state" }; } cachedUser = res.data?.user || null; verifiedOnce = true; return { success: true, user: cachedUser };
    } catch (err) { const msg = err?.response?.data?.error || err?.message || "Login failed"; return { success: false, message: msg }; }
}

export async function logout() {
    try { await api.post("/auth/logout"); } catch (_) { }
    try {
        localStorage.removeItem(AUTH_KEY);

    } catch (_) { } cachedUser = null; verifiedOnce = false; mePromise = null;
}

export async function getMe() {
    try {
        const res = await api.get("/auth/me"); const user = res.data?.user;
        if (user) {
            cachedUser = user; return { success: true, user };
        } return { success: false, message: "Invalid response" };
    }
    catch (err) {
        const msg = err?.response?.data?.error || err?.message || "Unable to load user";
        return { success: false, message: msg };
    }
}

export async function getEmail() {
    try {
        const res = await api.get("/email"); const email = res.data?.email;
        if (typeof email === "string") { return { success: true, email }; }
        return { success: false, message: "Invalid response" };
    } catch (err) {
        const msg = err?.response?.data?.error || err?.message || "Unable to load email";
        return { success: false, message: msg };
    }
}

export async function updateEmail({ email, password, confirmPassword }) {
    try {
        const res = await api.post("/email", { email, password, confirmPassword });
        const token = res.data?.token;
        if (token) { try { localStorage.setItem(AUTH_KEY, token); } catch (_) { } }
        const user = res.data?.user;
        if (user) { cachedUser = user; }
        verifiedOnce = true;
        return { success: true, user: cachedUser };
    } catch (err) {
        const msg = err?.response?.data?.error || err?.message || "Update failed";
        return { success: false, message: msg };
    }
}

export function getToken() {
    try { return localStorage.getItem(AUTH_KEY); } catch (_) { return null; }
}

export function getUser() { return cachedUser; }
